import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import NotFound from 'scenes/NotFound';

import Info from './Info';
import List from './List';

const Newzz = () => {
  return (
    <Switch>
      <Redirect exact to={'/producer/news/list'} path={'/producer/news'} />
      <Route path={'/producer/news/list'} component={List} />
      <Route path={'/producer/news/info/:newzzId'} component={Info} />
      <Route path='*' component={NotFound} />
    </Switch>
  );
};
export default Newzz;
